import { render, staticRenderFns } from "./floor.vue?vue&type=template&id=450f069d"
import script from "./floor.vue?vue&type=script&lang=js"
export * from "./floor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports